export default {
  TITLE: 'Service settings',
  DESCRIPTION: 'Don’t worry, you can change these later!'
};
